var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaJttIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.952,
    height: 90.026,
    viewBox: "0 0 78.952 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minerva_jtt_icon",
    transform: "translate(-1345 -8993.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minerva_jtt_icon-2",
    "data-name": "minerva_jtt_icon",
    transform: "translate(1345 8993.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186334",
    "data-name": "\\uADF8\\uB8F9 186334",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186332",
    "data-name": "\\uADF8\\uB8F9 186332",
    transform: "translate(7.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186323",
    "data-name": "\\uADF8\\uB8F9 186323",
    transform: "translate(4.232 4.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186322",
    "data-name": "\\uADF8\\uB8F9 186322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139208",
    "data-name": "\\uD328\\uC2A4 139208",
    d: "M128.791,122.721H65.7a1.821,1.821,0,0,1-1.821-1.821V38.747A1.821,1.821,0,0,1,65.7,36.926h63.091a1.821,1.821,0,0,1,1.821,1.821V120.9A1.821,1.821,0,0,1,128.791,122.721Z",
    transform: "translate(-63.879 -36.926)",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186331",
    "data-name": "\\uADF8\\uB8F9 186331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186329",
    "data-name": "\\uADF8\\uB8F9 186329",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186324",
    "data-name": "\\uADF8\\uB8F9 186324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139209",
    "data-name": "\\uD328\\uC2A4 139209",
    d: "M97.959,27.631H56.4a1.821,1.821,0,0,0-1.821,1.821v82.153a1.821,1.821,0,0,0,1.821,1.821H119.5a1.821,1.821,0,0,0,1.821-1.821V50.233Z",
    transform: "translate(-54.583 -27.631)",
    fill: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186326",
    "data-name": "\\uADF8\\uB8F9 186326",
    transform: "translate(1.82 1.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186325",
    "data-name": "\\uADF8\\uB8F9 186325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139210",
    "data-name": "\\uD328\\uC2A4 139210",
    d: "M59.49,107.438a.913.913,0,0,1-.91-.91V32.54a.914.914,0,0,1,.269-.642.9.9,0,0,1,.642-.269H85.657a.91.91,0,1,1,0,1.821H60.4v73.077A.91.91,0,0,1,59.49,107.438ZM89.3,33.451a.91.91,0,1,1,.91-.91A.91.91,0,0,1,89.3,33.451Z",
    transform: "translate(-58.58 -31.63)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186327",
    "data-name": "\\uADF8\\uB8F9 186327",
    transform: "translate(0 18.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139211",
    "data-name": "\\uD328\\uC2A4 139211",
    d: "M116.764,67.605V128.83a1.821,1.821,0,0,1-1.821,1.821H54.583v2.731A1.821,1.821,0,0,0,56.4,135.2H119.5a1.821,1.821,0,0,0,1.821-1.821V72.01Z",
    transform: "translate(-54.583 -67.605)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186328",
    "data-name": "\\uADF8\\uB8F9 186328",
    transform: "translate(0 20.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139212",
    "data-name": "\\uD328\\uC2A4 139212",
    d: "M119.04,72.444v61.3a1.821,1.821,0,0,1-1.821,1.821H54.583v.455a1.821,1.821,0,0,0,1.821,1.821H119.5a1.821,1.821,0,0,0,1.821-1.821V74.646Z",
    transform: "translate(-54.583 -72.444)",
    fill: "#d1d3d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186330",
    "data-name": "\\uADF8\\uB8F9 186330",
    transform: "translate(43.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139213",
    "data-name": "\\uD328\\uC2A4 139213",
    d: "M149.867,48.527a1.707,1.707,0,0,0,1.707,1.707h21.651l-23.357-22.6Z",
    transform: "translate(-149.867 -27.631)",
    fill: "#d1d3d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186333",
    "data-name": "\\uADF8\\uB8F9 186333",
    transform: "translate(0 6.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139214",
    "data-name": "\\uD328\\uC2A4 139214",
    d: "M80.039,57.829H38.859a1.821,1.821,0,0,1-1.821-1.821V43.395a1.821,1.821,0,0,1,1.821-1.821h41.18a1.821,1.821,0,0,1,1.821,1.821V56.008A1.821,1.821,0,0,1,80.039,57.829Z",
    transform: "translate(-37.038 -41.574)",
    fill: "#2266d3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186353",
    "data-name": "\\uADF8\\uB8F9 186353",
    transform: "translate(16.494 31.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186347",
    "data-name": "\\uADF8\\uB8F9 186347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186343",
    "data-name": "\\uADF8\\uB8F9 186343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139220",
    "data-name": "\\uD328\\uC2A4 139220",
    d: "M93.771,100.534H75.386a2.116,2.116,0,0,1-2.116-2.116h0A2.116,2.116,0,0,1,75.386,96.3H93.771a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,93.771,100.534Z",
    transform: "translate(-73.27 -96.302)",
    fill: "#5e9cf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186344",
    "data-name": "\\uADF8\\uB8F9 186344",
    transform: "translate(0 12.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139221",
    "data-name": "\\uD328\\uC2A4 139221",
    d: "M93.771,128.73H75.386a2.116,2.116,0,0,1-2.116-2.116h0a2.116,2.116,0,0,1,2.116-2.116H93.771a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,93.771,128.73Z",
    transform: "translate(-73.27 -124.498)",
    fill: "#5e9cf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186345",
    "data-name": "\\uADF8\\uB8F9 186345",
    transform: "translate(0 25.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139222",
    "data-name": "\\uD328\\uC2A4 139222",
    d: "M93.771,156.925H75.386a2.116,2.116,0,0,1-2.116-2.116h0a2.116,2.116,0,0,1,2.116-2.116H93.771a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,93.771,156.925Z",
    transform: "translate(-73.27 -152.693)",
    fill: "#5e9cf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186346",
    "data-name": "\\uADF8\\uB8F9 186346",
    transform: "translate(0 38.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139223",
    "data-name": "\\uD328\\uC2A4 139223",
    d: "M93.771,185.121H75.386A2.116,2.116,0,0,1,73.27,183h0a2.116,2.116,0,0,1,2.116-2.116H93.771A2.116,2.116,0,0,1,95.887,183h0A2.116,2.116,0,0,1,93.771,185.121Z",
    transform: "translate(-73.27 -180.889)",
    fill: "#5e9cf7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186352",
    "data-name": "\\uADF8\\uB8F9 186352",
    transform: "translate(27.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186348",
    "data-name": "\\uADF8\\uB8F9 186348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139224",
    "data-name": "\\uD328\\uC2A4 139224",
    d: "M153.547,100.534H135.162a2.116,2.116,0,0,1-2.116-2.116h0a2.116,2.116,0,0,1,2.116-2.116h18.386a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,153.547,100.534Z",
    transform: "translate(-133.046 -96.302)",
    fill: "#2266d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186349",
    "data-name": "\\uADF8\\uB8F9 186349",
    transform: "translate(0 12.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139225",
    "data-name": "\\uD328\\uC2A4 139225",
    d: "M153.547,128.73H135.162a2.116,2.116,0,0,1-2.116-2.116h0a2.116,2.116,0,0,1,2.116-2.116h18.386a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,153.547,128.73Z",
    transform: "translate(-133.046 -124.498)",
    fill: "#2266d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186350",
    "data-name": "\\uADF8\\uB8F9 186350",
    transform: "translate(0 25.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139226",
    "data-name": "\\uD328\\uC2A4 139226",
    d: "M153.547,156.925H135.162a2.116,2.116,0,0,1-2.116-2.116h0a2.116,2.116,0,0,1,2.116-2.116h18.386a2.116,2.116,0,0,1,2.116,2.116h0A2.116,2.116,0,0,1,153.547,156.925Z",
    transform: "translate(-133.046 -152.693)",
    fill: "#2266d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186351",
    "data-name": "\\uADF8\\uB8F9 186351",
    transform: "translate(0 38.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139227",
    "data-name": "\\uD328\\uC2A4 139227",
    d: "M153.547,185.121H135.162A2.116,2.116,0,0,1,133.046,183h0a2.116,2.116,0,0,1,2.116-2.116h18.386A2.116,2.116,0,0,1,155.663,183h0A2.116,2.116,0,0,1,153.547,185.121Z",
    transform: "translate(-133.046 -180.889)",
    fill: "#2266d3"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139404",
    "data-name": "\\uD328\\uC2A4 139404",
    d: "M26.649,17.624a2.827,2.827,0,0,1-.972,2.274,4.063,4.063,0,0,1-2.715.827A11.67,11.67,0,0,1,20.7,20.5V18.671h.193a4.8,4.8,0,0,0,1.606.351,2.741,2.741,0,0,0,1.058-.176,1.2,1.2,0,0,0,.62-.568,4.432,4.432,0,0,0,.2-1.7V11.843H22.059V10.189h4.589ZM37.1,11.912H33.694v8.661H31.42V11.912H28.009V10.189h9.1Zm9.795,0H43.489v8.661H41.215V11.912H37.8V10.189h9.1Z",
    transform: "translate(1333.013 8992.887)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaJttIcon);
export default __webpack_public_path__ + "static/media/minerva_jtt_icon.64cb495174103421c6fbd7dac496e310.svg";
export { ForwardRef as ReactComponent };